module.exports = __webpack_public_path__ + "static/media/airdrop-active.a88d37ee.svg";